import { map } from 'rxjs/operators';
import { logger } from '../logger';
import { pipe } from 'rxjs';
export function firstFromGroup() {
    return pipe(map((group) => {
        if (!Array.isArray(group)) {
            logger.error(`firstFromGroup must be piped an array`);
            return group;
        }
        return group[0];
    }));
}
//# sourceMappingURL=first_from_group.js.map